export default "__VITE_ASSET__CQxH_dCh__"